<template>
  <div v-if="summary">
    <p>Refunds and cancellation do not remove purchased hours or other benefits.</p>
    <p v-if="blocked" class="text-danger">Resolve pending payments or financial reconciliation before continuing. Closed orders cannot collect payment.</p>
    <div class="form-group">
      <label for="refund-purpose">What should this refund do?</label>
      <select id="refund-purpose" v-model="purpose" class="form-control" @change="changed">
        <option disabled value="">Choose an option</option>
        <option value="reduce_obligation">Reduce what the student owes</option>
        <option value="recollect">Return money to collect it again</option>
      </select>
    </div>
    <div v-if="returnsAll" class="form-group">
      <label for="refund-cancel-order">This returns all collected order money. Also cancel the order and stop collection?</label>
      <select id="refund-cancel-order" v-model="cancel" class="form-control" @change="changed">
        <option disabled value="">Choose an option</option>
        <option value="yes">Yes, cancel the order</option>
        <option value="no">No, keep the remaining obligation</option>
      </select>
      <p>A canceled order cannot be reopened. Further collection requires a new order.</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    summary: { type: Object, default: null },
    amount: { type: Number, default: null },
    resetKey: { type: Number, default: 0 },
  },
  data() { return { purpose: '', cancel: '' }; },
  computed: {
    returnsAll() { return this.summary && this.amount !== null && Number(this.amount) > 0 && Math.round(Number(this.amount) * 100) === this.summary.net_received; },
    blocked() { return this.summary && (this.summary.pending_amount > 0 || this.summary.reconciliation_required || this.summary.collection_closed); },
  },
  methods: {
    changed() {
      this.$emit('decision-change', {
        purpose: this.purpose,
        ...(this.returnsAll && this.cancel !== '' ? { cancel_order: this.cancel === 'yes' } : {}),
        valid: !this.blocked && this.purpose !== '' && (!this.returnsAll || this.cancel !== ''),
      });
    },
  },
  mounted() { this.changed(); },
  watch: {
    amount() { this.changed(); },
    summary() { this.changed(); },
    resetKey() { this.purpose = ''; this.cancel = ''; this.changed(); },
  },
};
</script>
